import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CreateChancel, Loader } from 'components';
import { FindLoad, FindSuccessItem, useModal } from 'utils';
import { adminActions, systemActions } from 'store';
import { staffModalsStyle } from './styles';

const ACTION_TYPE = 'ASSIGN_ZOOM_ACCOUNT';

export const AssignZoomModal = ({ staffId }) => {
    const dispatch = useDispatch();
    const { close } = useModal();
    const classes = staffModalsStyle();
    const { zoomUsers, adminInfoById } = useSelector((state) => ({
        zoomUsers: state.system.zoomUsers,
        adminInfoById: state.admins.adminInfoById,
    }));
    const loader = FindLoad(ACTION_TYPE);
    const loadZoomUsers = FindLoad('GET_ZOOM_USERS');
    const success = FindSuccessItem(ACTION_TYPE);

    const [selectedUserId, setSelectedUserId] = useState(adminInfoById?.telehealth?.zoomUserId || '');

    useEffect(() => {
        dispatch(systemActions.getZoomUsers());
    }, []);

    useEffect(() => {
        if (success) {
            close();
        }
    }, [success]);

    const handleSave = () => {
        if (!selectedUserId) return;
        const selectedUser = zoomUsers.find((u) => u.id === selectedUserId);
        if (!selectedUser) return;
        dispatch(
            adminActions.assignZoomAccount(staffId, {
                zoomUserId: selectedUser.id,
                zoomUserName: selectedUser.displayName,
                zoomUserEmail: selectedUser.email,
            })
        );
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Assign Zoom Account</p>
            <p className="modal-header-sub">Select a Zoom account to be used for this staff telehealth meetings.</p>
            <div className="modal-body-wrapper" style={{ minHeight: 200, maxHeight: 400, overflow: 'auto' }}>
                {loadZoomUsers?.length ? (
                    <div>
                        <Loader height={200} />
                    </div>
                ) : // <p className={classes.zoomModalLoading}>Loading Zoom users...</p>
                zoomUsers?.length ? (
                    <div className={classes.zoomModalList}>
                        {zoomUsers.map((user) => {
                            const isSelected = selectedUserId === user.id;
                            return (
                                <div
                                    key={user.id}
                                    onClick={() => setSelectedUserId(user.id)}
                                    className={isSelected ? classes.zoomModalItemSelected : classes.zoomModalItem}
                                >
                                    <div className={isSelected ? classes.zoomModalRadioSelected : classes.zoomModalRadio} />
                                    <div>
                                        <p className={classes.zoomModalUserName}>{user.displayName}</p>
                                        <p className={classes.zoomModalUserEmail}>{user.email}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <p className={classes.zoomModalEmpty}>No Zoom users found.</p>
                )}
            </div>
            <CreateChancel
                loader={!!loader?.length}
                create="Save"
                chancel="Cancel"
                onClose={close}
                buttonWidth="100%"
                onCreate={handleSave}
                disabled={!selectedUserId}
            />
        </div>
    );
};
